import { PriceItem } from '../../service/prototype/type';
import { safeParseJson } from '../Prototype/Edit/util';

export const getPrice = ({ prices }: { prices?: PriceItem[] }) => {
  const pricesForPublish = prices?.filter((price) => price.is_for_publish);
  const price = pricesForPublish?.[0];
  return price?.final_target_price || 0;
};

export const getFabricAndFillingNameEn = ({
  prices,
  sources,
}: {
  prices?: PriceItem[];
  sources?: any[];
}) => {
  const pricesForPublish = prices?.filter((price) => price.is_for_publish);
  const price = pricesForPublish?.[0];
  const details = price?.details;
  const fabricSourceIds = details
    ?.filter((detail) => detail.source_entity_name === 'Fabric')
    ?.map((detail) => detail.source_id);
  const fillingSourceIds = details
    ?.filter((detail) => detail.source_entity_name === 'Filling')
    ?.map((detail) => detail.source_id);
  const fabrics = sources?.filter((source) =>
    fabricSourceIds?.includes(source.id)
  );
  const fillings = sources?.filter((source) =>
    fillingSourceIds?.includes(source.id)
  );
  const fabricEngNames = fabrics
    ?.map((fabric) => fabric.fabric_name_en)
    ?.join('/');
  const fabricEngNameTokens = fabricEngNames
    ?.split(/[\s/]+/)
    ?.filter((token) => /^[a-zA-Z]+$/.test(token))
    ?.map((token) => token.toLowerCase());
  const uniqueFabricEngNameTokens = Array.from(new Set(fabricEngNameTokens));
  const fabricNameEn = uniqueFabricEngNameTokens?.join('/');
  const productParamsJson = safeParseJson(price?.product_params_json || '');
  const { filling_weight, unit } = productParamsJson.filling || {};
  const fillingWeight = `${filling_weight}${unit}`;
  const fillingNameEn = fillings?.map(
    (filling) =>
      `${productParamsJson.filling?.filling_percentages?.[filling.id]}% ${
        filling.filling_name_en
      }`
  );
  return {
    fabricNameEn,
    fillingWeight,
    fillingNameEn,
  };
};
